import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff6b6b',
      light: '#ff8787',
      dark: '#ee5a52',
    },
    secondary: {
      main: '#4ecdc4',
      light: '#7dd8d0',
      dark: '#45b7ae',
    },
    accent: {
      main: '#ffd93d',
      light: '#ffe066',
      dark: '#f4c430',
    },
    background: {
      default: '#0f1419',
      paper: 'rgba(22, 28, 36, 0.8)',
    },
    text: {
      primary: '#f8f9fa',
      secondary: '#c9d1d9',
    },
  },
  typography: {
    fontFamily: '"Inter", "Noto Sans JP", sans-serif',
    h1: {
      fontFamily: '"Excellence In Motion", "Inter", "Noto Sans JP", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.02em',
      color: '#f8f9fa',
    },
    h2: {
      fontFamily: '"Excellence In Motion", "Inter", "Noto Sans JP", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.02em',
      color: '#f8f9fa',
    },
    h3: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      fontWeight: 600,
    },
    body1: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      lineHeight: 1.8,
      fontSize: '1.05rem',
      color: '#f8f9fa',
    },
    body2: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      lineHeight: 1.7,
      fontSize: '0.95rem',
      color: '#c9d1d9',
    },
    button: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      fontWeight: 600,
      letterSpacing: '0.025em',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
          padding: '12px 32px',
          fontWeight: 600,
          transition: 'all 0.2s ease',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)',
          color: '#ffffff !important',
          boxShadow: '0 4px 15px rgba(255, 107, 107, 0.4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #ff8787 0%, #ff6b6b 100%)',
            boxShadow: '0 6px 20px rgba(255, 107, 107, 0.5)',
            color: '#ffffff !important',
          },
        },
        outlinedPrimary: {
          borderColor: '#ff6b6b',
          borderWidth: 2,
          color: '#ff6b6b',
          '&:hover': {
            borderColor: '#ff8787',
            backgroundColor: 'rgba(255, 107, 107, 0.1)',
            borderWidth: 2,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, rgba(22, 28, 36, 0.9) 0%, rgba(30, 40, 52, 0.8) 100%)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          borderRadius: 16,
          transition: 'all 0.3s ease',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            borderColor: 'rgba(255, 107, 107, 0.3)',
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontSize: '0.75rem',
          fontWeight: 600,
        },
        filled: {
          background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.15), rgba(78, 205, 196, 0.15))',
          color: '#ff8787',
          border: '1px solid rgba(255, 107, 107, 0.3)',
        },
      },
    },
  },
});

export default theme;

